module.exports = __webpack_public_path__ + "static/media/settings.e06d908b.svg";